<template>
  <dp-draft-edit :subNavTitle="title" :capsule="capsule" :saveMessage="saveMessage"></dp-draft-edit>
</template>

<script>
  import CreateTemplate from '../../requests/creationPages/PRCreateTemplate.vue'
  export default {
    name: 'Capsule-Draft-Edit',
    data: () => {
      return {
        title: 'Request to Pay - Edit Draft',
        capsule: 'draft-edit',
        saveMessage: 'Draft saved'
      }
    },
    components: {
      'dp-draft-edit': CreateTemplate
    }
  }
</script>
